<ng-container [ngSwitch]="matTemplateTypeObs | async">
  <ng-container *ngSwitchCase="'fromTemplate'">

    <div class="flex-row">
      <img
        *ngIf="(matOptionTemplateValuesObs | async)?.imgSrc"
        [src]="(matOptionTemplateValuesObs | async)?.imgSrc"
        class="template-img"
      />

      <div class="full-height flex-grow-1">

        <h3 *ngIf="(matOptionTemplateValuesObs | async)?.title" class="display-block mat-headline-6 margin-none">
          {{ (matOptionTemplateValuesObs | async)?.title }}
          
          <span
            *ngIf="(matOptionTemplateValuesObs | async)?.subtitle"
            class="mat-body-2"
            >({{ (matOptionTemplateValuesObs | async)?.subtitle }})
          </span>
        </h3>

        <p *ngFor="let descriptionPart of descriptionPartsObs | async" class="display-block margin-none">
          {{ descriptionPart }}
        </p>
  
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'basic'">
    {{ displayObs | async | translate }}
  </ng-container>
</ng-container>
